import type { FormFieldDto } from '../../form.types';
import { FormChoiceTile } from './FormChoiceTile';
import { TILES_CLASS } from './field.styles';

interface FormFieldRadioProps {
    field: FormFieldDto;
}

export function FormFieldRadio({ field }: FormFieldRadioProps) {
    return (
        <div className={TILES_CLASS}>
            {field.choices?.map((choice) => (
                <FormChoiceTile
                    key={choice._key ?? choice.value}
                    choice={choice}
                    type="radio"
                    name={field.name}
                    // One required radio makes the whole group required.
                    required={field.required}
                    defaultChecked={choice.value === field.options?.defaultValue}
                />
            ))}
        </div>
    );
}
